export const sports = {
  name: 'sports',
  path: '/sports',
  component: () => import('@/views_mobile/member/sports'),
  redirect: { name: 'sportsWelcome' },
  meta: {
    layout: 'mobile-default',
    text: '스포츠',
    gnb: false
  },
  children: [
    {
      name: 'sportsWelcome',
      path: '/sports/welcome',
      component: () => import('@/views_mobile/member/sports/welcome'),
      props: true,
      meta: {
        layout: 'mobile-default',
        text: '스포츠 웰컴 화면',
        gnb: false
      }
    },
    {
      name: 'sportsViewer',
      path: '/sports/play/:vendor/:gameCode',
      component: () => import('@/views_mobile/member/sports/viewer'),
      props: true,
      meta: {
        layout: 'mobile-default',
        text: '스포츠 게임 화면',
        gnb: false
      }
    },
    {
      name: 'sportsHistory',
      path: '/sports/history',
      component: () => import('@/views_mobile/member/sports/history'),
      props: true,
      meta: {
        layout: 'mobile-default',
        text: '화면구성설명',
        gnb: false
      }
    }
  ]
}
